/** @format */

import { request } from '@power/runtime-vue3';
import type { BaseResponse } from '@power/runtime-vue3';

// 组织管理-组织人员-点击加入
export function queryWoutOrg(data: API.positionParam) {
	return request<BaseResponse<API.BaseConfigResult>>({
		url: '/base/rbac/employee/queryWoutOrg',
		method: 'post',
		data,
	});
}
